
export function getCurrentLanguage() {
  const language = localStorage.getItem("language") || "English";
  return language.toLowerCase();
}



// WEBPACK FOOTER //
// ./src/helpers/local_storage.js